import { attendanceApi } from '@mathflat/domain/Attendance'
import type { Student } from '@mathflat/domain/Student'
import { useQuery } from '@tanstack/react-query'

/** 학생 출석 리스트 조회 (날짜 범위, yyyy-MM-dd). */
export const useStudentAttendances = (
  studentId: string | null | undefined,
  startDate: string,
  endDate: string,
) =>
  useQuery({
    queryKey: ['student-attendances', studentId, startDate, endDate],
    queryFn: () =>
      attendanceApi.getStudentAttendances(studentId as Student['id'], { startDate, endDate }),
    enabled: !!studentId,
    staleTime: 0,
  })
